import { useLayoutEffect } from 'react';
import { InspectionTemplateItemModel } from 'components/dataProviders/withRequiredInspectionTemplate/types';
import { scrollToActiveCard } from './scroll';
export function useScrollToActiveTemplate(
  active: string | undefined,
  canScroll: boolean,
  loading: boolean,
  filteredTemplates: InspectionTemplateItemModel[],
  projectId: string,
  setCanScroll: (value: boolean) => void,
  getCard: (id: string) => HTMLElement | undefined,
  getContainer: () => HTMLElement | undefined
): void {
  useLayoutEffect(() => {
    if (!active || !projectId || loading || filteredTemplates.length === 0) {
      return;
    }

    const isActiveInFiltered = filteredTemplates.some(t => t._id === active);
    if (!isActiveInFiltered) {
      return;
    }

    if (!canScroll) {
      return;
    }

    setCanScroll(false);

    const cardElement = getCard(active);
    const container = getContainer();

    if (cardElement) {
      requestAnimationFrame(() => {
        scrollToActiveCard(cardElement, container);
      });
    }
  }, [active, canScroll, projectId, loading, filteredTemplates, setCanScroll, getCard, getContainer]);
}
